import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', () => {

  // Scrolling parallax effect for heroes
  document.querySelectorAll('.hero').forEach(el => {
    const layers = el.querySelector('.hero__layers');

    gsap.set(layers, { y: -170, scale: 1.05 });
    gsap.to(layers, {
      y: 170,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        scrub: true,
      }
    });
  });

  // Scrolling parallax effect for banners
  document.querySelectorAll('.banner').forEach(el => {
    const layers = el.querySelector('.banner__layers');

    gsap.set(layers, { y: -100, scale: 1.10 });
    gsap.to(layers, {
      y: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        scrub: true,
      }
    });
  });

  // Scrolling parallax effect for fingerprint
  document.querySelectorAll('.fingerprint').forEach(el => {

    gsap.set(el, { y: -100, scale: 1.05 });
    gsap.to(el, {
      y: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        scrub: true,
      }
    });
  });

  // Scrolling parallax effect for section images
  document.querySelectorAll('.section__image img').forEach(el => {

    gsap.set(el, { y: 0, scale: 1.15 });
    gsap.to(el, {
      y: 0,
      scale: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        scrub: true,
      }
    });
  });

});
